// Internazionalization data
const languages = [{
    id: "en",
    name: "English"
},
{
    id: "es",
    name: "Spanish"
},
{
    id: "de",
    name: "Deutsch"
}
];

// Return a lang object data if id exist (eg. "en", "es", "de", etc), otherwise return an array with all lang availables.
export default function (idLang) {

    const result = languages.filter(obj => {
        return obj.id === idLang
    })

    if (result.length > 0) {
        return result;
    } else {
        return languages;
    }
        
}
